import { Input, HostBinding, EventEmitter, Output, Directive } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from '../../../../core/components/base.component';
import { FilterType } from '../../../../core/enums/filter-type';
import { Filter } from '../../../../core/models/filter';
import { BoolFilterType, DateTimeFilterType, GuidFilterType, NumberFilterType, StringFilterType } from '../../../../core/services/api-services';

@Directive()
export abstract class BaseFilterComponent<TFilterType extends StringFilterType | NumberFilterType | DateTimeFilterType | BoolFilterType | GuidFilterType> extends BaseComponent {
  // Initial Input
  @Input() initialValue: Filter<TFilterType> | null = null;

  // PropertyName to Filter (usually the column-name of the filter)
  @Input() propertyName!: string;

  // Filter Active Class
  @HostBinding('class.header-filter-active') activeFilterField = false;

  // Output event where event needs to be binded
  @Output() filterChanged = new EventEmitter<{ filter: Filter<TFilterType> | null, filterType: FilterType, propertyName: string }>();

  // Last selected Filter
  currentValue = new BehaviorSubject<Filter<TFilterType> | null>(null);

  abstract filterType: FilterType;

  constructor() {
    super();
  }

  init(): void {
    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  abstract clearFilter(): void;

  onClear(): void {
    this.currentValue.next(null);
    this.filterChanged.emit({ filter: null, filterType: this.filterType, propertyName: this.propertyName });
    this.activeFilterField = false;
    this.clearFilter();
  }
}
